import React, { FC } from "react";
import { Button, Image, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import laptopMagnifier from "@/assets/studentTile/laptop-magnifier.svg?url";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import IconTileContentLayout from "@/js/components/StudentTile/components/IconTileContentLayout";
import { ChakraFAIcon } from "@/components/ui/Icon";

interface StudentTileRetryAvailableProps {
	useScreenshotRetry: () => void;
}

const StudentNoActivityDetected: FC<StudentTileRetryAvailableProps> = (props: StudentTileRetryAvailableProps) => {
	const { t } = useTranslation();
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	return (
		<Flex flexDirection={"column"} align={"center"} justifyContent={"center"} height={"100%"}>
			<IconTileContentLayout>
				<Image src={laptopMagnifier} htmlHeight={42} htmlWidth={42} mb={tileSize === "lg" ? 4 : 1} />
				<Text fontWeight={"bold"} lineHeight={1.2}>
					{t("studentTile.noActivityDetectedTitle")}
				</Text>
				{tileSize !== "sm" && <Text lineHeight={1.2}>{t("studentTile.noActivityDetectedHint")}</Text>}
				<Button
					size="sm"
					py={2}
					px={4}
					mb={tileSize === "lg" ? 4 : 0}
					mt={tileSize !== "sm" ? 4 : 0}
					onClick={() => props.useScreenshotRetry()}
					fontSize={12}
					variant={"outline"}
					backgroundColor={"#f8f8f9"}
				>
					<ChakraFAIcon fontSize={8} icon={"fa-refresh"} variant="solid" mr={2} />
					{t("studentTile.noActivityDetectedRetry")}
				</Button>
			</IconTileContentLayout>
		</Flex>
	);
};

export default StudentNoActivityDetected;
